import "./OurProducts2.module.css";
import Header from "@/reusable_sections/Header";
import Productshowcase from "./sections/Productshowcase";
import Productcategoryfilters from "./sections/Productcategoryfilters";
import Footer from "@/reusable_sections/Footer";
export default function OurProducts2Page() {
  return <div>
      <Header />
      <Productshowcase />
      <Productcategoryfilters />
      <Footer />
    </div>;
}